import { SalaDeAula } from '@/services/resources'

function initialState () {
  return {
    enrollment: {
      id: null,
      treeData: [],
      breadcrumbLessonTopic: []
    }
  }
}

function changeLessonProgress (id, element, progress) {
  // eslint-disable-next-line no-prototype-builtins
  if (element.hasOwnProperty('nodes')) {
    let progressAvg = 0
    element.nodes.forEach(element => {
      progressAvg += changeLessonProgress(id, element, progress)
    })
    element.progress = progressAvg > 0 ? (progressAvg / element.nodes.length) : progressAvg
    return element.progress
    // eslint-disable-next-line no-prototype-builtins
  } else if (element.hasOwnProperty('id')) {
    if (element.id === parseInt(id)) {
      element.progress = progress
    }
    return element.progress
  }
}

function changeActiveLesson (treeData, aulaId, breadcrumbLessonTopic) {
  treeData.active = false
  // eslint-disable-next-line no-prototype-builtins
  if (treeData.hasOwnProperty('nodes')) {
    treeData.nodes.forEach(element => {
      element.active = false
      const retornoChildrens = changeActiveLesson(element, aulaId, breadcrumbLessonTopic)
      treeData.active = treeData.active || retornoChildrens
      if (retornoChildrens) {
        breadcrumbLessonTopic.unshift(treeData.text)
      }
    })
  } else {
    if (Number(aulaId) === treeData.id) {
      treeData.active = true
    }
  }
  return treeData.active
}

const state = initialState()

const getters = {
  enrollment (state) {
    return state.enrollment
  },
  enrollmentId (state) {
    return state.enrollment.id
  },
  enrollmentTreeData (state) {
    return state.enrollment.treeData
  },
  breadcrumbLessonTopic (state) {
    return state.enrollment.breadcrumbLessonTopic
  }
}

const mutations = {
  resetState (state) {
    state = initialState()
  },
  setTreeData (state, treeData) {
    state.enrollment.treeData = treeData
  },
  setEnrollmentId (state, enrollmentId) {
    state.enrollment.id = enrollmentId
  },
  updateLessonProgress (state, { lessonId, progress }) {
    changeLessonProgress(lessonId, state.enrollment.treeData[0], progress)
  },
  updateActiveLesson (state, lessonId) {
    state.enrollment.breadcrumbLessonTopic = []
    changeActiveLesson(state.enrollment.treeData[0], lessonId, state.enrollment.breadcrumbLessonTopic)
    // Deixa a tree fechada quando a tela é menor que 960px
    state.enrollment.treeData[0].active = window.innerWidth > 960
  },
  setbreadcrumbLessonTopic (state, value) {
    state.enrollment.breadcrumbLessonTopic = value
  }
}

const actions = {
  updateLessonProgress (context, { enrollmentId, lessonId, progress }) {
    return SalaDeAula.updateLessonProgress(enrollmentId, lessonId, progress)
      .then(response => {
        context.commit('updateLessonProgress', { enrollmentId, lessonId, progress: response.data.progress })
        return response
      })
  },
  initSalaDeAula (context, { enrollmentId, lessonId }) {
    return SalaDeAula.getSyllabus(enrollmentId)
      .then(response => {
        const treeData = [{ text: response.data.course.name, nivelCurso: true, nodes: response.data.syllabus.topics, progress: response.data.syllabus.progress }]
        state.enrollment.breadcrumbLessonTopic = []
        changeActiveLesson(treeData[0], lessonId || response.data.currentLesson, state.enrollment.breadcrumbLessonTopic)
        // Deixa a tree fechada quando a tela é menor que 960px
        treeData[0].active = window.innerWidth > 960
        context.commit('setTreeData', treeData)
        return response
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
